import { createContext, useContext } from "react";

const TabIdContext = createContext<number | null>(null);

export const TabIdProvider = TabIdContext.Provider;

export function useTabId(): number | null {
  return useContext(TabIdContext);
}
